import { I18nForm } from '@dsivd/prestations-ng';

import { Attachments } from './attachments';
import { CareerApplicant } from './career-applicant';
import { InformationApplicant } from './information-applicant';
import { LegalRepresentative } from './legal-representative';
import { PersonneReference } from './personne-reference';
import { ProfessionalProject } from './professional-project';
import { RequestOrigin } from './request-origin';
import { RequestSummary } from './request-summary';

export class BusinessForm extends I18nForm {

    professionalProject: ProfessionalProject = new ProfessionalProject();

    requestOrigin: RequestOrigin = new RequestOrigin();

    informationApplicant: InformationApplicant = new InformationApplicant();

    personnesReference: PersonneReference = new PersonneReference();

    careerApplicant: CareerApplicant = new CareerApplicant();

    requestSummary: RequestSummary = new RequestSummary();

    attachments: Attachments = new Attachments();

    legalRepresentative: LegalRepresentative = new LegalRepresentative();

}
